var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-row',{staticClass:"p-3"},[_c('b-col',[_c('h1',[_vm._v(_vm._s(_vm.title))])]),_c('b-col')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }